export const environment = {
  production: true,
apiUrl:'https://api.trafobola.com/api/v1/'
};
